import { render, staticRenderFns } from "./CallStatisticsByTimePeriod.vue?vue&type=template&id=c5253d52&"
import script from "./CallStatisticsByTimePeriod.vue?vue&type=script&lang=js&"
export * from "./CallStatisticsByTimePeriod.vue?vue&type=script&lang=js&"
import style0 from "./CallStatisticsByTimePeriod.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports